.addButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 32px;
  width: 32px;
  border-radius: var(--bc-border-radius, 8px);
  border: 1px dashed var(--bc-color-border, #E4EEF5);
  background: transparent;
  cursor: pointer;
  color: var(--bc-color-text-secondary, #5A7494);

  &:hover {
    border-color: var(--bc-color-primary, #0092FF);
    color: var(--bc-color-primary, #0092FF);
  }
}

.addMenuRoot {
  min-width: 240px;
}

.addMenuSearch {
  margin-bottom: var(--bc-margin-xs, 8px);
}

.addMenuList {
  max-height: 240px;
  overflow-y: auto;
}

.addMenuItem {
  display: flex;
  align-items: center;
  gap: var(--bc-margin-xs, 8px);
  padding: 6px 8px;
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background: var(--bc-color-fill-tertiary, #F6F6F3);
  }
}

.addMenuItemDisabled {
  opacity: 0.5;
  pointer-events: none;
}
